const TOUR_SCROLL_PADDING_PX = 24;

/** Nearest ancestor that can scroll vertically (overflow auto/scroll with overflow content). */
export function getVerticalScrollParent(element: Element): HTMLElement | null {
  let parent = element.parentElement;
  while (parent) {
    const { overflowY } = window.getComputedStyle(parent);
    if (
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      parent.scrollHeight > parent.clientHeight + 1
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
}

/** Scroll only as much as needed inside the nearest scroll container — avoids tour layout jumps. */
export function scrollTourTargetIntoView(target: Element, padding = TOUR_SCROLL_PADDING_PX): void {
  const scrollParent = getVerticalScrollParent(target);
  if (!scrollParent) {
    target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
    return;
  }

  const parentRect = scrollParent.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();

  if (targetRect.top < parentRect.top + padding) {
    scrollParent.scrollTop += targetRect.top - parentRect.top - padding;
  } else if (targetRect.bottom > parentRect.bottom - padding) {
    scrollParent.scrollTop += targetRect.bottom - parentRect.bottom + padding;
  }
}
